import React, { Component } from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import { Typography, CoreIcons } from 'components';

class NpsNumber extends Component {
  state = { selected: this.props.selected }

  componentWillReceiveProps(nextProps) {
    this.setState({ selected: nextProps.selected });
  }

  handleToggle = (e) => {
    e.preventDefault();

    this.setState({ selected: !this.state.selected }, function() {
      // IF THIS METHOD IS PASSED VIA PROPS
      // UPDATE PARENT STATE CONTROL OF THIS CHILD (COMPONENTE ITSELF)
      if (this.props.onClickToggle) {
        this.props.onClickToggle(this.state.selected);
      }
      // IF THIS METHOD IS PASSED VIA PROPS
      // UPDATE PARENT STATE CONTROL OF THIS CHILD (COMPONENTE ITSELF)
    });
  }
  
  render() {
    const {
      qustionId,
      number,
    
    } = this.props;

    const { selected } = this.state;

    return (
      <div className={`NpsNumber ${selected ? 'active' : ''}`}>

        <div className={`NpsNumber__circle--${number}`} 
          onClick={this.props.handleClick}
          id={qustionId}>
          <Typography bold color='white' align ='center'>
            {number}
          </Typography>
        </div>
        <div className={`NpsNumber__icon ${selected ? 'active' : ''}`}>
          { selected ?
            <CoreIcons  
              name='Check'
              fill="#4B4B4B"
              height='20px'
        
            />
            : <div style={{ height: '20px' }}></div>
          }
        </div>

      </div>
    );
  }
}

NpsNumber.propTypes = {
  disabled: PropTypes.bool,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconViewBox: PropTypes.string,
  qustionId: PropTypes.string,
  onClickToggle: PropTypes.func,
  onHandleToggle: PropTypes.func,
  parentControl: PropTypes.bool,
  selected: PropTypes.bool,
  title: PropTypes.any,
  value: PropTypes.any,
  number: PropTypes.string,
  itemId: PropTypes.string,
  handleClick: PropTypes.func,
  
};

NpsNumber.defaultProps = {
  disabled: false,
  iconWidth: '20px',
  iconHeight: '20px',
  iconViewBox: '2 2 20 20',
  parentControl: false,
  selected: false,
  title: 'select',
  number: 0,
};

export default NpsNumber;